import { useCallback, useMemo, useRef } from "react";
function supportsLocalStorage() {
    const test = "test";
    try {
        const storage = window.localStorage;
        storage.setItem(test, test);
        storage.removeItem(test);
        return true;
    } catch  {
        return false;
    }
}
function getPathValue(object, path) {
    const names = (path || "").split(".");
    let current = object;
    for(let i = 0; current && i < names.length; i++){
        current = current[names[i]];
    }
    return current;
}
function setPathValue(object, path, value) {
    const names = path.split(".");
    if (!names.length) {
        return;
    }
    let current = object;
    for(let i = 0; i < names.length - 1; i++){
        const key = names[i];
        if (!current[key] || typeof current[key] !== "object") {
            current[key] = {};
        }
        current = current[key];
    }
    current[names[names.length - 1]] = value;
}
const useTreeStorage = (treeId)=>{
    const memoryRef = useRef({});
    const canPersist = Boolean(treeId) && supportsLocalStorage();
    const storageKey = treeId ? `AIOT-${treeId}` : undefined;
    const readPersisted = useCallback(()=>{
        if (!canPersist || !storageKey) {
            return memoryRef.current;
        }
        try {
            return JSON.parse(window.localStorage.getItem(storageKey) || "{}");
        } catch  {
            return {};
        }
    }, [
        canPersist,
        storageKey
    ]);
    const writePersisted = useCallback((data)=>{
        if (!canPersist || !storageKey) {
            memoryRef.current = data;
            return;
        }
        window.localStorage.setItem(storageKey, JSON.stringify(data));
    }, [
        canPersist,
        storageKey
    ]);
    const getItem = useCallback((path)=>{
        const data = readPersisted();
        return path ? getPathValue(data, path) : data;
    }, [
        readPersisted
    ]);
    const setItem = useCallback((path, value)=>{
        const data = {
            ...readPersisted()
        };
        setPathValue(data, path, value);
        writePersisted(data);
    }, [
        readPersisted,
        writePersisted
    ]);
    return useMemo(()=>({
            getItem,
            setItem
        }), [
        getItem,
        setItem
    ]);
};
export { useTreeStorage };
